"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.cashBalancePointerConfig = exports.cashBalanceFeedPointerMethod = exports.mapParafinBalanceReportCsvToCashBalancesCsv = void 0;
const _ = __importStar(require("lodash"));
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const mapCsvToBorrowerCashBalancesFeed_1 = require("../mapCsvToBorrowerCashBalancesFeed");
// Map from Ramp-uploaded cash balances CSV to standard borrower cash balances CSV
const mapParafinBalanceReportCsvToCashBalancesCsv = (csvArray, reportingDate, creditFacilityId) => {
    // https://finleytechnologies.slack.com/archives/C02PVLGH31C/p1639500370037500
    const parafinCashBalances = csvArray.find((csvRow) => csvRow.balance_type === 'closing_available');
    (0, common_1.finleyAssert)(parafinCashBalances && _.isNumber(Number(parafinCashBalances.amount)), `Expected to find Parafin cash balances property from 'closing_available'`);
    const balance = (Number(parafinCashBalances.amount) / 100).toString();
    return [
        {
            facility_id: creditFacilityId,
            reportingDate,
            balance_type: finley_types_1.Bank.BorrowerAccountType.Collections,
            balance,
            refresh_date: reportingDate,
        },
    ];
};
exports.mapParafinBalanceReportCsvToCashBalancesCsv = mapParafinBalanceReportCsvToCashBalancesCsv;
const cashBalanceFeedPointerMethod = ({ borrowerId, csvArray, reportingDate, fileVersion, creditFacilityId, }) => {
    const mappedCsvArray = (0, exports.mapParafinBalanceReportCsvToCashBalancesCsv)(csvArray, reportingDate, creditFacilityId);
    return (0, mapCsvToBorrowerCashBalancesFeed_1.mapCsvToBorrowerCashBalancesFeed)({
        borrowerId,
        csvArray: mappedCsvArray,
        reportingDate,
        fileVersion,
        creditFacilityId,
    });
};
exports.cashBalanceFeedPointerMethod = cashBalanceFeedPointerMethod;
exports.cashBalancePointerConfig = {
    pointer: 'parafinSiliconValleyBank1',
    method: exports.cashBalanceFeedPointerMethod,
};
//# sourceMappingURL=cashBalanceFeedPointerMethod.js.map